import { useState } from 'react';
import classNames from "classnames";
import { If } from "react-conditional-components-renderer";

import { pluralizeIfNecessary } from "@ascendnow/shared";
import { CoinsIcon, LockIcon, MoreIcon } from "../../AscIcons";
import AscGenericCard from "../AscGenericCard/AscGenericCard";

import styles from "./AscRecordingCard.module.scss";
import AscAdminAction from "../../AscAdminAction/AscAdminAction";
import AscButton from "../../AscButton/AscButton";
import AscParagraph from "../../AscTypography/AscParagraph/AscParagraph";

type AscRecordingCardType = "workshop" | "competition" | "webinar";

export interface AscRecordingCardProps {
  title: string;
  coverImageUrl?: string;
  priceInCoins: number;
  type: AscRecordingCardType;
  purchased?: boolean;
  onClick?: () => void;
  onUnlock?: () => void;
  onWatchRecording?: () => void;
  className?: string;
  bodyClassName?: string;
  footerClassName?: string;
  loading?: boolean;
  variant?: string;
  onDelete?: () => void;
  onEdit?: () => void;
}

export default function AscRecordingCard({
  title,
  coverImageUrl,
  priceInCoins,
  type,
  purchased = false,
  className,
  bodyClassName,
  footerClassName,
  loading = false,
  variant,
  onClick,
  onUnlock,
  onWatchRecording,
  onDelete,
  onEdit
}: AscRecordingCardProps) {
  const [showAction, setShowAction] = useState<boolean>(false);

  function handleUnlock(e: { stopPropagation: () => void }) {
    e?.stopPropagation();
    onUnlock?.();
  }
  function handleWatchRecording(e: { stopPropagation: () => void }) {
    e?.stopPropagation();
    onWatchRecording?.();
  }

  const handleOnEdit = () => {
    onEdit && onEdit();
    setShowAction(false);
  };

  const handleOnDelete = () => {
    onDelete && onDelete();
    setShowAction(false);
  };


  return (
    <AscGenericCard
      className={classNames(styles.ground, className)}
      titleClassName={styles.cardTitle}
      title={title}
      coverImageUrl={coverImageUrl}
      onClick={onClick}
      bodyClassName={bodyClassName}
      footerClassName={footerClassName}
      loading={loading}
      tags={
        variant === "admin"
          ? [
              <>
                <MoreIcon
                  className={styles.moreIcon}
                  data-testid={"asc-skill-card-more-icon"}
                  onClick={() => setShowAction(!showAction)}
                />
                {showAction && (
                  <AscAdminAction
                    option1={"Edit"}
                    option2={"Delete"}
                    clickOption1={handleOnEdit}
                    clickOption2={handleOnDelete}
                    className={styles.adminAction}
                  />
                )}
              </>,
            ]
          : []
      }
      footer={
        purchased ? (
          <AscButton narrowPadding fullWidth onClick={handleWatchRecording}>
            Watch recording
          </AscButton>
        ) : (
          <>
            <If test={!variant}>
              <AscButton
                narrowPadding
                fullWidth
                iconClassName={styles.lockIconWrapper}
                icon={<LockIcon />}
                onClick={handleUnlock}
              >
                Unlock for {priceInCoins} coins
              </AscButton>
            </If>

            <If test={variant === "admin"}>
              <div className={styles.footerSection}>
                <CoinsIcon className={styles.icon} />
                <AscParagraph className={styles.priceCoins}>
                  {priceInCoins} {pluralizeIfNecessary("coin", priceInCoins)}
                </AscParagraph>
              </div>
            </If>
          </>
        )
      }
    >
      <div className={styles.typeLabel}>{type}</div>
    </AscGenericCard>
  );
}
